export const BADGES = /** @type {const} */({
  FIRST_ON_NBC_NEWS: 'FIRST ON NBC NEWS',
  ANALYSIS: 'ANALYSIS',
  FIRST_ON_NBC: 'FIRST ON NBC',
  BREAKING_NEWS: 'BREAKING NEWS',
  BREAKING: 'BREAKING',
  LIVE: 'LIVE',
  DEVELOPING: 'DEVELOPING',
  EXCLUSIVE: 'EXCLUSIVE',
  SPECIAL_REPORT: 'SPECIAL REPORT',
  WATCH: 'WATCH',
  DATA_GRAPHIC: 'DATA GRAPHIC',
  SPORTS: 'SPORTS',
  EYEBROW: 'EYEBROW',
});
